import { filter, includes, isEmpty } from "lodash";
import InstallmentDto from "../../PaymentContainerClient/dtos/InstallmentDto";
import PaymentDto from "../../PaymentContainerClient/dtos/PaymentDto";

interface FailedPaymentWithDetailedInstallments {
    error: string;
    paymentCreatedAt: string;
    installments: InstallmentDto[];
}

export default function getFailedPaymentsWithDetailedInstallments(
    installments: InstallmentDto[],
    payments: PaymentDto[]
): FailedPaymentWithDetailedInstallments[] {
    const paymentsWithError = filter(
        payments,
        (payment) => !isEmpty(payment.details.errorMessage)
    );

    return paymentsWithError
        .map((paymentWithError) => ({
            error: paymentWithError.details.errorMessage!,
            paymentCreatedAt: paymentWithError.createdAt,
            installments: filter(installments, (installment) =>
                includes(paymentWithError.installmentIds, installment.id)
            ),
        }))
        .filter((paymentWithError) => !isEmpty(paymentWithError.installments));
}
